<template>
	<v-container class="fun none-fluid link">
		<banner>Fun</banner>
		<div class="mx-auto fun-content">
			<div v-for="link in links" :key="link">
				<div v-html="$sanitize(link)"></div>
			</div>
		</div>
	</v-container>
</template>

<script>
import Banner from "../global/Banner";
import { getAllFuns } from "../../service/about/fun";

export default {
	components: {
		Banner
	},
	data() {
		return {
			links: []
		};
	},
	mounted() {
		getAllFuns()
			.then(links => {
				this.links = links;
			})
			.catch(err => {
				console.error(err.message);
			});
	}
};
</script>
